import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Flex from '../../Flex'
import Icon from '../../Icon'
import Copy from '../../Copy'
import Box from '../../Box'
import { themeColor } from '../../../util/themeLenses'
import { FormattedNumber } from 'react-intl'

export const Container = styled(Flex)`
    box-shadow: 0px 2px 4px 0px ${themeColor('lightGray40')};
    border: 1px solid ${themeColor('lightGray40')};
    min-height: 125px;
    border-radius: 2px;
`

export const InfoContainter = styled(Box)`
    position: relative;
`

export const DistanceContainer = styled.div`
    min-width: 120px;
    padding-left: 1em;
    border-left: 1px solid ${themeColor('lightGray60')};
`

const DistanceMetres = ({ distance: distanceInMeters, ...restProps }) => {
    const formattedProps = distanceInMeters >= 1E3
        ? { value: distanceInMeters / 1E3 }
        : { value: distanceInMeters }
    const unit = distanceInMeters >= 1E3
    ? 'km'
    : 'm'
    return <Copy padding='0' as='span' {...restProps}>
        <FormattedNumber style='decimal' maximumFractionDigits={2} {...formattedProps} />
        {''}
        {unit}
    </Copy>
}
DistanceMetres.propTypes = {
    distance: PropTypes.number,
}

const DistanceText = ({ distance }) => <div>
    <Icon color='gray' fontSize='large' type='car-filled' />
    <Copy as='span' padding='0 0 0 0.5em' color='gray' fontWeight='medium' fontSize='small'>
        <DistanceMetres distance={distance} fontSize='small'/>
    </Copy>
</div>

DistanceText.propTypes = {
    distance: PropTypes.number.isRequired,
}

export { DistanceText }
